module.exports = __webpack_public_path__ + "img/no-data-exercise.7b65c815.svg";